module.exports = {"530402001":"玉兴街道","530402002":"凤凰街道","530402003":"玉带街道","530402004":"北城街道","530402005":"春和街道","530402006":"李棋街道","530402007":"大营街街道","530402008":"研和街道","530402009":"高仓街道","530402201":"小石桥彝族乡","530402202":"洛河彝族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530402.json
// module id = 2698
// module chunks = 0